<template>
    <div>
        <div class="row template-container">
            <div class="col-6 d-flex">
                <burofax-template-preview-page-settings
                    :expedient="expedient"
                    @updatedSettings="updateData"
                />
            </div>

            <div class="col-6">
                <pdf-previewer :src="pdf_preview_content" height="90vh" width="100%"></pdf-previewer>
            </div>
        </div>

        <div class="actions-buttons-section">
            <router-link
                :to="{name: 'expedient.template.preview', params: {expedient: this.$router.currentRoute.value.params.expedient, template: this.$router.currentRoute.value.params.template}}">
                <button type="button" class="btn btn-primary rounded-btn">
                    <span class="uq-icon bi-arrow-left"></span>
                </button>
            </router-link>

            <div class="buttons-container">
                <button type="button" title="Descargar PDF" class="btn btn-danger icon-wrapper rounded-btn"
                        @click="downloadPDF" v-if="pdf_base64_content !== ''">
                    <span class="uq-icon bi-download"></span>
                </button>

                <button :disabled="!selected" type="button" title="Enviar Burofax"
                        class="btn btn-outline-success rounded-btn"
                        @click="sendBurofax">
                    <span class="uq-icon bi-arrow-right vertical-center"></span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import {getExpedient} from "../../helpers/requests/RequestsExpedients";
import {getTemplate} from "../../helpers/requests/RequestsTemplates";
import HtmlEditor from "./parts/HtmlEditor";
import {htmlToRawPreviewablePdf} from "../../helpers/requests/RequestsPDFs";
import PdfPreviewer from "./parts/PdfPreviewer";
import {parseHTML} from "../../helpers/requests/RequestsHTML";
import {downloadPdf} from "../../helpers/PDFUtils";
import {createBurofax} from "../../helpers/requests/RequestsBurofaxes";
import {can} from "../../helpers/Permissions";
import {
    deleteGeneratedDocument,
    getGeneratedDocumentWithUserExpedientAndTemplate,
    storeGeneratedDocument
} from "../../helpers/requests/RequestsGeneratedDocuments";
import router from "../../router";
import BurofaxTemplatePreviewPageSettings from "./parts/BurofaxTemplatePreviewPageSettings.vue";

export default {
    name: "BurofaxTemplatePreviewPage",
    components: {
        BurofaxTemplatePreviewPageSettings,
        PdfPreviewer,
        HtmlEditor
    },
    props: {},
    setup() {
        return {
            can,
        }
    },
    data() {
        return {
            status: {
                app: 'loading'
            },

            expedient: {},
            template: {},

            pdf_preview_content: '',
            pdf_base64_content: '',
            html_content: '',
            load_editor: false,

            timers: {
                preview_pdf: '',
            },

            previouslyGeneratedDocument: {},

            clientEmail: '',

            data: {
                type: '',
                burofax_type: '',
                selected: '',
                plazo: '',
                plazo_disponibilidad: '',
                es_electronico: '',
                acuse_recibo: '',
                copia_certificada: '',
                copia_testimonial: '',
                copia_testimonial_notario: '',
            }
        }
    },
    computed: {
        // TODO: This is also used in TemplateEdit.vue. Move it to only change once if needed
        emailCharactersLimit() {
            return 1200;
        },
        userCanChangeReceiver() {
            return can('burofax.change.receiver');
        },
        userCanChangeOptions() {
            return can('burofax.change.options');
        }
    },
    async mounted() {
        await this.loadExpedient();
        await this.loadTemplate();
        await this.applyPdfPreview();
    },
    methods: {
        async loadExpedient() {
            this.expedient = await getExpedient(this.$router.currentRoute.value.params.expedient);

            this.clientEmail = this.expedient.clients[0].email_01;

            this.selected = this.expedient.entities[0];
        },
        async loadTemplate() {
            this.template = await getTemplate(this.$router.currentRoute.value.params.template);

            // Here we need to parse the template, but receive html
            let params = {
                client: this.expedient.clients[0].id,
                entity: this.expedient.entities[0].id,
                expedient: this.expedient.id,
            }

            if (this.expedient.lawyers.length > 0) {
                params.lawyer = this.expedient.lawyers[0].id;
            }
            if (this.expedient.attorneys.length > 0) {
                params.attorney = this.expedient.attorneys[0].id;
            }

            // We load previously generated documentation if exists, or just the template content
            this.previouslyGeneratedDocument = await getGeneratedDocumentWithUserExpedientAndTemplate(window.user.id, this.$router.currentRoute.value.params.expedient, this.$router.currentRoute.value.params.template);

            if (!!this.previouslyGeneratedDocument && !!this.previouslyGeneratedDocument.content) {
                // window.setTimeout(() => alert('Hemos cargado tu última versión del ' + new Date(this.previouslyGeneratedDocument.created_at).toLocaleString() + '. Puedes hacer clic en el botón de la papelera para empezar de cero o continuar con esta versión.'), 2000);
                this.html_content = this.previouslyGeneratedDocument.content;
            } else {
                this.html_content = await parseHTML(this.template.content, params);
            }

            this.load_editor = true;
        },
        async applyPdfPreview() {
            // Here we are editing only content, so we need to push header and footer
            let html = this.html_content;

            if (!!this.template.header) {
                html = this.template.header + html;
            }

            if (!!this.template.footer) {
                html = this.template.footer + html;
            }

            let pdfContent = await htmlToRawPreviewablePdf(html);
            this.pdf_base64_content = escape(pdfContent);
            this.pdf_preview_content = "data:application/pdf;base64," + escape(pdfContent);
        },
        async downloadPDF() {
            await this.saveSnapshot();

            await downloadPdf(this.pdf_base64_content, this.expedient.clients[0].code + '_' + this.expedient.entities[0].short_name + '_' + this.template.display_name.replaceAll(' ', '-') + '.pdf');
        },
        async deleteChanges() {
            if (confirm('Se borrarán todos los cambios realizados hasta ahora y empezarás a editar desde 0. ¿Estás seguro?')) {
                await deleteGeneratedDocument(this.$router.currentRoute.value.params.expedient, window.user.id, this.$router.currentRoute.value.params.template, this.previouslyGeneratedDocument.id);
                window.location.reload();
            }
        },
        async saveSnapshot() {
            this.previouslyGeneratedDocument = await storeGeneratedDocument(this.html_content, this.template.content, this.$router.currentRoute.value.params.expedient, this.$router.currentRoute.value.params.template);
        },
        async sendBurofax() {
            try {
                await createBurofax(this.expedient.id, this.template.id, this.data);

                alert('Burofax enviado con éxito.');

                await router.push({name: 'expedient.update', params: {expedient: this.expedient.id}});
            } catch (e) {
                if (!!e?.response?.data?.message) {
                    alert(e.response.data.message);
                } else {
                    alert('Ha ocurrido un error al enviar el burofax');
                }
            }
        },
        updateData(data) {
            this.data = data;
        }
    },
}
</script>
